import { Avatar, Box, Stack, Typography } from '@lingoda/ui';
import { ChalkboardTeacherIcon } from '@lingoda/ui/icons/lingodaIcons';
import { trans } from '@lingoda/i18n';
import type { PostCheckoutClass } from '../../../types';

type Teacher = PostCheckoutClass['teacher'];

interface ParticipantsProps {
    teacher: Teacher;
}

export const Teacher = ({ teacher }: ParticipantsProps) => (
    <Box marginTop={3} flex={1} display="flex" alignItems="center" flexDirection="row">
        <Box display="inline-flex" flexShrink={0} width={({ spacing }) => spacing(6)} pt={0.25}>
            <ChalkboardTeacherIcon size={24} />
        </Box>
        <Stack flexWrap="wrap" alignItems="center" direction="row" my={-0.75} width="100%">
            {teacher ? (
                <>
                    <Box display="flex" flexGrow={1} py={0.75} mr={2}>
                        <Typography variant="body1">
                            {teacher?.firstName} {teacher?.lastName}
                        </Typography>
                    </Box>
                    <Box display="flex" py={0.75}>
                        <Avatar size={28} src={teacher?.photo?.urls.medium} borderVariant="stacked">
                            {teacher?.firstName} {teacher?.lastName}
                        </Avatar>
                    </Box>
                </>
            ) : (
                <Typography>{trans('teacher-will-be-assigned', {}, 'student-common')}</Typography>
            )}
        </Stack>
    </Box>
);
